module.exports = __webpack_public_path__ + "img/img-87dfaf.jpg";